"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _servicesCore = require("@makerdao/services-core");

var _contracts = _interopRequireDefault(require("../../contracts/contracts"));

var _tokens = _interopRequireDefault(require("../../contracts/tokens"));

var _networks = _interopRequireWildcard(require("../../contracts/networks"));

var _ethers = require("ethers");

var _wrapContract = require("./smartContract/wrapContract");

var _mapValues = _interopRequireDefault(require("lodash/mapValues"));

var _assert = _interopRequireDefault(require("assert"));

var SmartContractService =
/*#__PURE__*/
function (_PrivateService) {
  (0, _inherits2.default)(SmartContractService, _PrivateService);

  function SmartContractService() {
    var _this;

    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'smartContract';
    (0, _classCallCheck2.default)(this, SmartContractService);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SmartContractService).call(this, name, ['web3', 'log', 'transactionManager'])); // aliases

    _this.getContract = _this.getContractByName;
    _this.getContractAddress = _this.getContractAddressByName;
    return _this;
  }

  (0, _createClass2.default)(SmartContractService, [{
    key: "initialize",
    value: function initialize() {
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (settings.addContracts) {
        this._addedContracts = Object.keys(settings.addContracts).reduce(function (acc, key) {
          var def = settings.addContracts[key];
          acc[key] = [(0, _objectSpread2.default)({}, def, {
            version: 1
          })];
          return acc;
        }, {});
      }

      this.get('transactionManager').get('proxy').setSmartContractService(this);
    }
  }, {
    key: "getContractByAddressAndAbi",
    value: function getContractByAddressAndAbi(address, abi) {
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          name = _ref.name,
          _ref$wrap = _ref.wrap,
          wrap = _ref$wrap === void 0 ? true : _ref$wrap;

      (0, _assert.default)(address, "Missing address for contract \"".concat(name, "\""));
      if (!name) name = this.lookupContractName(address);
      var web3Service = this.get('web3');
      var signerOrProvider = web3Service.get('accounts').hasAccount() ? web3Service.getEthersSigner() : web3Service.getEthersSigner().provider;
      var contract = new _ethers.Contract(address, abi, signerOrProvider);
      var txManager = wrap && this.get('transactionManager');
      return (0, _wrapContract.wrapContract)(contract, name, abi, txManager);
    }
  }, {
    key: "getContractAddressByName",
    value: function getContractAddressByName(name) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          version = _ref2.version;

      var _this$_getContractInf = this._getContractInfo(name, version),
          address = _this$_getContractInf.address;

      return address;
    }
  }, {
    key: "getContractAddresses",
    value: function getContractAddresses() {
      return (0, _mapValues.default)(this._getAllContractInfo(), function (versions) {
        var latest = Math.max.apply(Math, (0, _toConsumableArray2.default)(versions.map(function (info) {
          return info.version;
        })));
        return versions.find(function (info) {
          return info.version === latest;
        }).address;
      });
    }
  }, {
    key: "getContractByName",
    value: function getContractByName(name) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          version = _ref3.version,
          _ref3$wrap = _ref3.wrap,
          wrap = _ref3$wrap === void 0 ? true : _ref3$wrap;

      var info = this._getContractInfo(name, version);

      return this.getContractByAddressAndAbi(info.address, info.abi, {
        name: name,
        wrap: wrap
      });
    }
  }, {
    key: "lookupContractName",
    value: function lookupContractName(address) {
      address = address.toUpperCase();

      var contracts = this._getAllContractInfo();

      var _arr = Object.keys(contracts);

      for (var _i = 0; _i < _arr.length; _i++) {
        var name = _arr[_i];
        var versions = contracts[name];

        if (versions.find(function (info) {
          return info.address && info.address.toUpperCase() === address;
        })) {
          return name;
        }
      }

      return null;
    }
  }, {
    key: "hasContract",
    value: function hasContract(name) {
      return Object.keys(_contracts.default).indexOf(name) > -1 || Object.keys(_tokens.default).indexOf(name) > -1 || Object.keys(this._addedContracts || {}).indexOf(name) > -1;
    } // generally we should be using the ethers contract interface. this is only
    // for edge cases that the ethers contract interface doesn't support, like
    // calling (but not sending) a non-constant function

  }, {
    key: "getWeb3ContractByName",
    value: function getWeb3ContractByName(name) {
      var _this$_getContractInf2 = this._getContractInfo(name),
          abi = _this$_getContractInf2.abi,
          address = _this$_getContractInf2.address;

      return this.get('web3').web3Contract(abi, address);
    }
  }, {
    key: "_getContractInfo",
    value: function _getContractInfo(name, version) {
      (0, _assert.default)(this.hasContract(name), "No contract found for \"".concat(name, "\""));

      var contracts = this._getAllContractInfo();

      var versions = contracts[name];
      if (!version) version = Math.max.apply(Math, (0, _toConsumableArray2.default)(versions.map(function (info) {
        return info.version;
      })));
      var contractInfo = versions.find(function (info) {
        return info.version === version;
      });

      if (!contractInfo) {
        throw new Error("Cannot find contract ".concat(name, ", version ").concat(version));
      }

      return contractInfo;
    }
  }, {
    key: "_getAllContractInfo",
    value: function _getAllContractInfo() {
      var id = this.get('web3').networkId(),
          mapping = _networks.default.find(function (m) {
        return m.networkId === id;
      });

      if (!mapping) throw new Error("Network ID ".concat(id, " not found in mapping."));
      var infos = mapping.contracts;

      if (this._addedContracts) {
        var _TESTNET_ID$1337$42$;

        var networkName = (_TESTNET_ID$1337$42$ = {}, (0, _defineProperty2.default)(_TESTNET_ID$1337$42$, _networks.TESTNET_ID, 'testnet'), (0, _defineProperty2.default)(_TESTNET_ID$1337$42$, 1337, 'testnet'), (0, _defineProperty2.default)(_TESTNET_ID$1337$42$, 42, 'kovan'), (0, _defineProperty2.default)(_TESTNET_ID$1337$42$, 1, 'mainnet'), _TESTNET_ID$1337$42$)[id];
        var infos2 = (0, _objectSpread2.default)({}, infos, (0, _mapValues.default)(this._addedContracts, function (_ref4, name) {
          var _ref5 = (0, _slicedToArray2.default)(_ref4, 1),
              definition = _ref5[0];

          var address = definition.address,
              otherProps = (0, _objectWithoutProperties2.default)(definition, ["address"]);
          if (typeof address === 'string') return [definition];

          if (!address || !address[networkName]) {
            throw new Error("Missing address for ".concat(name, " on ").concat(networkName));
          }

          return [(0, _objectSpread2.default)({
            address: address[networkName]
          }, otherProps)];
        }));
        return infos2;
      }

      return infos;
    }
  }]);
  return SmartContractService;
}(_servicesCore.PrivateService);

exports.default = SmartContractService;